import React from 'react';
import { handleChange } from 'lib/stores/formStore';
import { formatIdFromName } from 'lib/utility';
import useFormField from 'lib/hooks/useFormField';

import FormLabel from './FormLabel';

const FormTextArea = ({ name, label, id, placeholder, hideLabel, required = false }) => {
  const [value] = useFormField(name);

  return (
    <div className="mb-3">
      {!hideLabel && (
        <FormLabel id={id || formatIdFromName(name)} label={label || name} required={required} />
      )}
      <textarea
        name={name}
        rows="4"
        value={value}
        onChange={handleChange}
        id={id || formatIdFromName(name)}
        data-testid={id || formatIdFromName(name)}
        placeholder={placeholder}
        required={required}
        className="form-control"
      />
    </div>
  );
};

export default FormTextArea;
